"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseNumber = void 0;
const is_number_1 = require("../is-number/is-number");
/**
 * @summary Parses a string into a float number.
 *
 * Parses a string to a number. Float values are accepted. Whitespace at the beginning and end are ignored.
 * Both `,` and `.` are accepted as decimal separators.
 *
 * If the string does not contain a number, returns `NaN`.
 *
 * @param {string | undefined} text
 * @returns {number}
 *
 * @example
 * const number = parseNumber('33.5');
 */
function parseNumber(text) {
    if (!text || !(0, is_number_1.isNumber)(text)) {
        return NaN;
    }
    const t = text.replace(/,/g, '.');
    return +t;
}
exports.parseNumber = parseNumber;
